module.exports = __webpack_public_path__ + "img/newLogo-old-2.bbe97710.png";